<div id="tender-contract-dashboard-supplier-awarded" class="container-fluid mt-5">
  <div class="card bg-white">
    <div class="card-body">
      <div class="row align-items-start">
        <div class="col-12 col-lg-4 mb-3">
          <h3>Fuel Supplier</h3>
          <div class="d-flex bg-light p-3">
            <div *ngIf="supplier.supplier.logo" class="flex-shrink-0 avatar avatar-96 bg-white rounded shadow">
              <img src="{{ supplier.supplier.logo }}" alt="{{ supplier.supplier.name }}">
            </div>
            <div *ngIf="!supplier.supplier.logo" class="flex-shrink-0 avatar avatar-96 bg-white rounded p-4 shadow">
              <svg fill="#c6c9d2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve" stroke="#c6c9d2">
                <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                <g id="SVGRepo_iconCarrier">
                  <g>
                    <path
                      d="M58,37.104V4c0-0.553-0.448-1-1-1H1C0.448,3,0,3.447,0,4v44c0,0.553,0.448,1,1,1h34.003c1.963,4.693,6.6,8,11.997,8 c7.168,0,13-5.832,13-13C60,41.465,59.26,39.105,58,37.104z M34.359,47H2V5h54v29.622c-0.17-0.164-0.354-0.311-0.532-0.465 c-0.088-0.075-0.171-0.155-0.261-0.228c-0.235-0.192-0.48-0.37-0.728-0.545c-0.092-0.065-0.181-0.135-0.275-0.198 c-0.245-0.163-0.498-0.312-0.754-0.458c-0.109-0.063-0.214-0.13-0.325-0.189c-0.077-0.041-0.154-0.083-0.232-0.123 c0.179-0.385,0.112-0.852-0.218-1.154l-12-11c-0.196-0.179-0.452-0.277-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325 l-9.794,10.727l-4.743-4.743c-0.374-0.373-0.972-0.391-1.368-0.044L6.339,41.249c-0.415,0.365-0.455,0.997-0.09,1.412 C6.447,42.886,6.723,43,7,43c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.203,0.203,0.47,0.295,0.736,0.287 C34.361,40.523,34,42.22,34,44c0,0.493,0.033,0.977,0.087,1.456c0.009,0.075,0.024,0.149,0.034,0.224 c0.056,0.428,0.131,0.849,0.227,1.262C34.353,46.961,34.354,46.981,34.359,47z M48.779,31.136 c-0.162-0.022-0.321-0.055-0.485-0.071C47.867,31.023,47.435,31,47,31c-4.773,0-8.942,2.593-11.203,6.437 c-0.036-0.054-0.06-0.114-0.107-0.162l-4.807-4.807l9.181-10.054l9.694,8.887c-0.067-0.015-0.133-0.032-0.2-0.045 C49.301,31.204,49.039,31.172,48.779,31.136z M47,55c-4.787,0-8.859-3.08-10.367-7.358c-0.094-0.267-0.176-0.536-0.249-0.806 c-0.015-0.058-0.03-0.115-0.045-0.173c-0.06-0.238-0.112-0.476-0.156-0.716c-0.024-0.133-0.042-0.267-0.061-0.401 c-0.026-0.18-0.054-0.36-0.071-0.54C36.021,44.674,36,44.339,36,44c0-6.065,4.935-11,11-11c0.426,0,0.848,0.031,1.265,0.079 c0.127,0.015,0.25,0.039,0.375,0.057c0.291,0.044,0.579,0.096,0.863,0.162c0.141,0.033,0.281,0.07,0.421,0.108 c0.268,0.074,0.531,0.159,0.792,0.253c0.134,0.048,0.269,0.094,0.4,0.147c0.295,0.119,0.583,0.255,0.866,0.399 c0.083,0.042,0.17,0.077,0.252,0.121c0.342,0.185,0.671,0.393,0.992,0.614c0.131,0.09,0.255,0.19,0.382,0.286 c0.199,0.15,0.395,0.305,0.584,0.469c0.127,0.11,0.251,0.224,0.373,0.339c0.193,0.184,0.379,0.377,0.559,0.575 c0.094,0.103,0.191,0.202,0.281,0.309c0.261,0.311,0.51,0.634,0.739,0.976C57.315,39.643,58,41.743,58,44 C58,50.065,53.065,55,47,55z">
                    </path>
                    <path
                      d="M51.95,39.051c-0.391-0.391-1.023-0.391-1.414,0L47,42.586l-3.536-3.535c-0.391-0.391-1.023-0.391-1.414,0 s-0.391,1.023,0,1.414L45.586,44l-3.536,3.535c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293L47,45.414l3.536,3.535c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c0.391-0.391,0.391-1.023,0-1.414L48.414,44l3.536-3.535C52.34,40.074,52.34,39.441,51.95,39.051z">
                    </path>
                    <path
                      d="M16,25.138c3.071,0,5.569-2.498,5.569-5.568C21.569,16.498,19.071,14,16,14s-5.569,2.498-5.569,5.569 C10.431,22.64,12.929,25.138,16,25.138z M16,16c1.968,0,3.569,1.602,3.569,3.569S17.968,23.138,16,23.138s-3.569-1.601-3.569-3.568 S14.032,16,16,16z">
                    </path>
                  </g>
                </g>
              </svg>
            </div>
            <div class="flex-grow-1 ms-3">
              <p class="fw-bold mb-0">{{ supplier.supplier.name }}</p>
              <address class="mb-0">
                <ng-contaainer *ngIf="supplier.supplier.address">{{ supplier.supplier.address }},<br></ng-contaainer>
                <ng-contaainer *ngIf="supplier.supplier.city">{{ supplier.supplier.city }}, </ng-contaainer>
                <ng-contaainer *ngIf="supplier.supplier.country && supplier.supplier.country.name">{{
                  supplier.supplier.country.name
                  }}</ng-contaainer>
              </address>
            </div>
          </div>
        </div>

        <div class="col-lg-8">
          <h3>Fuel Supply Team</h3>
          <div class="row">
            <div class="col-12 col-lg-6 col-xxl-4" *ngFor="let user of supplier.supplier.users; let index = index;">
              <div class="d-flex bg-light p-3">
                <div *ngIf="user.logo" class="flex-shrink-0 avatar avatar-96 bg-white rounded shadow">
                  <img src="{{ user.logo }}" alt="{{ user.lastName }}">
                </div>
                <div *ngIf="!user.logo" class="flex-shrink-0 avatar avatar-96 bg-white rounded p-4 shadow">
                  <svg fill="#c6c9d2" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 60 60" xml:space="preserve"
                    stroke="#c6c9d2">
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path
                          d="M58,37.104V4c0-0.553-0.448-1-1-1H1C0.448,3,0,3.447,0,4v44c0,0.553,0.448,1,1,1h34.003c1.963,4.693,6.6,8,11.997,8 c7.168,0,13-5.832,13-13C60,41.465,59.26,39.105,58,37.104z M34.359,47H2V5h54v29.622c-0.17-0.164-0.354-0.311-0.532-0.465 c-0.088-0.075-0.171-0.155-0.261-0.228c-0.235-0.192-0.48-0.37-0.728-0.545c-0.092-0.065-0.181-0.135-0.275-0.198 c-0.245-0.163-0.498-0.312-0.754-0.458c-0.109-0.063-0.214-0.13-0.325-0.189c-0.077-0.041-0.154-0.083-0.232-0.123 c0.179-0.385,0.112-0.852-0.218-1.154l-12-11c-0.196-0.179-0.452-0.277-0.72-0.262c-0.265,0.012-0.515,0.129-0.694,0.325 l-9.794,10.727l-4.743-4.743c-0.374-0.373-0.972-0.391-1.368-0.044L6.339,41.249c-0.415,0.365-0.455,0.997-0.09,1.412 C6.447,42.886,6.723,43,7,43c0.234,0,0.47-0.082,0.66-0.249l16.313-14.362l10.302,10.301c0.203,0.203,0.47,0.295,0.736,0.287 C34.361,40.523,34,42.22,34,44c0,0.493,0.033,0.977,0.087,1.456c0.009,0.075,0.024,0.149,0.034,0.224 c0.056,0.428,0.131,0.849,0.227,1.262C34.353,46.961,34.354,46.981,34.359,47z M48.779,31.136 c-0.162-0.022-0.321-0.055-0.485-0.071C47.867,31.023,47.435,31,47,31c-4.773,0-8.942,2.593-11.203,6.437 c-0.036-0.054-0.06-0.114-0.107-0.162l-4.807-4.807l9.181-10.054l9.694,8.887c-0.067-0.015-0.133-0.032-0.2-0.045 C49.301,31.204,49.039,31.172,48.779,31.136z M47,55c-4.787,0-8.859-3.08-10.367-7.358c-0.094-0.267-0.176-0.536-0.249-0.806 c-0.015-0.058-0.03-0.115-0.045-0.173c-0.06-0.238-0.112-0.476-0.156-0.716c-0.024-0.133-0.042-0.267-0.061-0.401 c-0.026-0.18-0.054-0.36-0.071-0.54C36.021,44.674,36,44.339,36,44c0-6.065,4.935-11,11-11c0.426,0,0.848,0.031,1.265,0.079 c0.127,0.015,0.25,0.039,0.375,0.057c0.291,0.044,0.579,0.096,0.863,0.162c0.141,0.033,0.281,0.07,0.421,0.108 c0.268,0.074,0.531,0.159,0.792,0.253c0.134,0.048,0.269,0.094,0.4,0.147c0.295,0.119,0.583,0.255,0.866,0.399 c0.083,0.042,0.17,0.077,0.252,0.121c0.342,0.185,0.671,0.393,0.992,0.614c0.131,0.09,0.255,0.19,0.382,0.286 c0.199,0.15,0.395,0.305,0.584,0.469c0.127,0.11,0.251,0.224,0.373,0.339c0.193,0.184,0.379,0.377,0.559,0.575 c0.094,0.103,0.191,0.202,0.281,0.309c0.261,0.311,0.51,0.634,0.739,0.976C57.315,39.643,58,41.743,58,44 C58,50.065,53.065,55,47,55z">
                        </path>
                        <path
                          d="M51.95,39.051c-0.391-0.391-1.023-0.391-1.414,0L47,42.586l-3.536-3.535c-0.391-0.391-1.023-0.391-1.414,0 s-0.391,1.023,0,1.414L45.586,44l-3.536,3.535c-0.391,0.391-0.391,1.023,0,1.414c0.195,0.195,0.451,0.293,0.707,0.293 s0.512-0.098,0.707-0.293L47,45.414l3.536,3.535c0.195,0.195,0.451,0.293,0.707,0.293s0.512-0.098,0.707-0.293 c0.391-0.391,0.391-1.023,0-1.414L48.414,44l3.536-3.535C52.34,40.074,52.34,39.441,51.95,39.051z">
                        </path>
                        <path
                          d="M16,25.138c3.071,0,5.569-2.498,5.569-5.568C21.569,16.498,19.071,14,16,14s-5.569,2.498-5.569,5.569 C10.431,22.64,12.929,25.138,16,25.138z M16,16c1.968,0,3.569,1.602,3.569,3.569S17.968,23.138,16,23.138s-3.569-1.601-3.569-3.568 S14.032,16,16,16z">
                        </path>
                      </g>
                    </g>
                  </svg>
                </div>
                <div class="flex-grow-1 ms-3">
                  <h5>{{ user.firstName }} {{ user.lastName }}</h5>
                  <ng-container *ngIf="user.title">{{ user.title }}<br></ng-container>
                  <a href="mailto:{{ user.email }}">{{ user.email }}</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container-fluid mt-5">
  <div class="row">
    <div class="col-12 col-lg-8">
      <div class="card bg-white container-fluid mb-3">

        <div class="row align-items-center">
          <div class="col d-flex flex-row align-items-center min-height border-bottom">
            <h1 class="page-title me-3">
              <jft-time-remaining [round]="round"></jft-time-remaining>
            </h1>
            <jft-round-status [status]="round.status"></jft-round-status>

            <ul class="nav nav-links ms-6">
              <!--                            <jft-round-controls-->
              <!--                                [tender]="tender"-->
              <!--                                [round]="round"-->
              <!--                                (onRoundChange)="roundChanged($event)"-->
              <!--                                [rounds]="rounds"-->
              <!--                                [contract]="contract"-->
              <!--                                [suppliersCount]="suppliers.length">-->
              <!--                            </jft-round-controls>-->
              <li class="nav-item">
                <jft-extend-round-button
                  *ngIf="[roundStatuses.ACTIVE, roundStatuses.EXPIRED, roundStatuses.AWAITING_REVIEW].includes(contract.currentRound.status) && canShowAdvancedActions()"
                  [tender]="tender" [contract]="contract" (onExtended)="onRoundExtend($event)" [class]="'nav-link'">
                </jft-extend-round-button>
              </li>
              <li class="nav-item" *ngIf="canShowAdvancedActions() && user.canManageAdvanced(tender)">
                <a [routerLink]="['/tenders',tender.id,'locations',contract.id,'dashboard', 'new-round']"
                  class="nav-link">Launch Next Round</a>
              </li>
              <li class="nav-item" *ngIf="supplier.status == offerStatuses.RECEIVED && user.canManage(tender)">
                <a href="javascript:void(0)" class="nav-link">
                  <jft-bid-edit-modal [tender]="tender" [contract]="contract" [offer]="supplier"
                    (onUpdated)="onUpdatedBidModal($event, supplier)"></jft-bid-edit-modal>
                </a>
              </li>
            </ul>
          </div>
        </div>


        <ng-container *ngIf="[offerStatuses.RECEIVED,
                    offerStatuses.AWARDED,
                    offerStatuses.DECLINED_SUBMITTED].includes(supplier.status)">

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Status
            </div>
            <div class="col-12 col-lg-4 p-3">
              <jft-offer-status [signature]="supplier.bid ? supplier.bid.signature : null" [status]="supplier.status"
                [awardedPercent]="supplier.awardedPercent">
              </jft-offer-status>
            </div>
            <div class="mt-2"
              *ngIf="user.canManage(tender) && supplier.bid && (!supplier.bid.signature && supplier.bid.status == offerStatuses.AWARDED)">
              <a placement="bottom" class="btn btn-danger small" [popoverTitle]="'Cancel Award'" [autoClose]="true"
                #p="ngbPopover" [ngbPopover]="deleteAward" href="javascript:void(0)">
                <span [hidden]="!loadingAward">
                  <div class="spinner-border spinner-border-sm me-1" role="status">
                    <span class="visually-hidden">Loading..</span>
                  </div>
                </span>
                Cancel Award
              </a>
              <ng-template #deleteAward>
                <button (click)="p.close()" class="btn btn-light btn-xs w-100">
                  Cancel
                </button>
                <button [disabled]="loadingAward" (click)="cancelAward(supplier)"
                  class="btn btn-outline-primary btn-xs w-100">
                  Confirm
                </button>
              </ng-template>
              <small class="form-text text-muted">
                You can cancel award if a supplier didn't confirm a bid
              </small>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.awardComment">
            <div class="col-12 col-lg-4 p-3">
              Award Comment
              <span class="badge bg-warning-subtle text-dark border border-warning-subtle ms-1 fw-normal">
                Visible to the supplier
              </span>
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Award Comment'"
                [text]="supplier.awardComment"></jft-read-more-modal>
            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              {{supplier.name}}
            </div>
            <div class="col-12 col-lg-4 p-3" *ngIf="supplier.status == offerStatuses.RECEIVED && user.canManage(tender)">
              <jft-award-button *ngIf="round.status !== roundStatuses.AWARDED" [offer]="supplier" [contract]="contract"
                [loadingAward]="loadingAward" (onAward)="award($event)">
              </jft-award-button>
              <span *ngIf="!round.isClosed && user.canManage(tender)" class="ms-2">
                <jft-decline-offer-button [offer]="supplier" [loading]="loadingDecline"
                  (onDecline)="declineOffer($event)">
                </jft-decline-offer-button>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Delivery Point
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ tender.company.settings.getFilteredOptionLabel('delivery_point', supplier.bid.fuelPreference) }}

              <span *ngIf="bidHistory.fuel_preference">
                <jft-bid-history-popover [dataField]="bidHistory.fuel_preference"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Price Base
              <div ngbDropdown class="d-inline-block float-end mw-75">
                <jft-index-date-range [dateRange]="''" [placeholder]="'Select Date Range'"
                  [class]="'form-control form-control-sm me-2'" (onDates)="onDateRange($event)"></jft-index-date-range>
              </div>
            </div>
            <div class="col-12 col-lg-4 p-3">
              <ng-container *ngIf="supplier.bid.plattsIndexPrice && supplier.bid.plattsIndexPrice.value">
                {{supplier.bid.plattsIndexPrice.value}} {{tender.currency.code}} / {{tender.units.code}}
              </ng-container>
              <span class="small" *ngIf="supplier.bid.plattsIndexPrice && !supplier.bid.plattsIndexPrice.value">
                Select date range to display average price base
              </span>
              <span *ngIf="supplier.bid.index">
                Index price
                <ng-container
                  *ngIf="supplier.bid.index.index_code">{{supplier.bid.index.index_code.provider}}</ng-container>
                <ng-container
                  *ngIf="supplier.bid.index.index_code">{{tender.company.settings.getFilteredOptionLabel('index',
                  supplier.bid.index.index_code)}}</ng-container>
                {{supplier.bid.index.bate?.name}}
                {{tender.company.settings.getFilteredOptionLabel('averaging_method',
                $safeNavigationMigration(supplier.bid.index?.averaging_method))}}
                {{supplier.bid.index.averaging_offset?.name}}
                {{supplier.bid.index.effective_day?.name}}
              </span>
              <div *ngIf="supplier.bid.marketPrice && supplier.bid.marketPrice.price">
                {{tender.company.settings.getFieldName('market_price', 'Market price')}}

                <div *ngIf="supplier.bid.marketPrice.source_type">
                  Source Type: {{supplier.bid.marketPrice.source_type?.name}}
                </div>
                <div *ngIf="supplier.bid.marketPrice.source_name">
                  Source name: {{supplier.bid.marketPrice.source_name}}
                </div>
              </div>

              <span *ngIf="bidHistory.price_base">
                <jft-bid-history-popover [dataField]="bidHistory.price_base"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Differential
            </div>
            <div class="col-12 col-lg-4 p-3">
              <span>

              </span>
              <span>
                <ng-template #popConvD1Title>Supplier's original amount unit/currency</ng-template>
                <ng-template #popConvD1Content>
                  <p><strong>{{supplier.bid.differential?.getLabel()}}</strong></p>
                </ng-template>
              </span>
              <span *ngIf="bidHistory.differential">
                <jft-bid-history-popover [dataField]="bidHistory.differential"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Volume Based Mandatory Fees & Taxes
            </div>
            <div class="col-12 col-lg-4 p-3">

              <div *ngFor="let volumeFee of supplier.bid.volumeFeesPercent; let index = index;">
                <span>
                  {{volumeFee.percent + '% ' + volumeFee.applied_field + ' ' + volumeFee.notes}}
                </span>
              </div>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              DFT &nbsp;
              <ng-template #popDFTTitle>What is DFT?</ng-template>
              <ng-template #popDFTContent>
                <p>Differential + volume based fees and taxes</p>
              </ng-template>
              <a href="javascript:void(0)" [ngbPopover]="popDFTContent" [popoverTitle]="popDFTTitle"><i
                  class="fas fa-info-circle mx-1" aria-hidden="true"></i></a>
            </div>
            <div class="col-12 col-lg-4 p-3">
              <span>
                <strong *ngIf="supplier.bid.dftc">{{supplier.bid.dftc.getLabel()}}</strong>
                <span *ngIf="!supplier.bid.dftc" class="text-muted">-</span>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Comparative Cost of Credit Terms
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ supplier.costOfPaymentTerms }}&nbsp;
              <ng-container *ngIf="supplier.bid?.dftc?.price?.currency">{{ supplier.bid.dftc.price.currency.code }} /
                {{contract.units.code}}</ng-container>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              DFTC&nbsp;
              <ng-template #popTitle>What is DFTC?</ng-template>
              <ng-template #popContent>
                <p>Differential + volume based fees and taxes + comparative payment terms</p>
              </ng-template>
              <a href="javascript:void(0)" [ngbPopover]="popContent" [popoverTitle]="popTitle"><i
                  class="fas fa-info-circle mx-1" aria-hidden="true"></i></a>
            </div>
            <div class="col-12 col-lg-4 p-3">

              <span>
                <ng-template #popConvD4Title>Supplier's original amount unit/currency</ng-template>
                <ng-template #popConvD4Content>
                  <span>
                    {{ supplier.costOfPaymentTotalPrice }}&nbsp;
                    <ng-container *ngIf="supplier.bid?.dftc?.price?.currency">{{ supplier.bid.dftc.price.currency.code
                      }} / {{contract.units.code}}</ng-container>
                  </span>
                </ng-template>
                <!--                                <a href="javascript:void(0)" [ngbPopover]="popConvD4Content" [popoverTitle]="popConvD4Title">-->
                <!--                                    <i class="fas fa-info-circle mx-1" aria-hidden="true"></i>-->
                <!--                                </a>-->
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Payment type
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ supplier.bid.isPaymentOpenInvoice() ? tender.company.settings.getFieldName(
              'open_invoice', 'Open Invoice') : 'Prepayment' }}

              <span *ngIf="bidHistory.payment_type">
                <jft-bid-history-popover [dataField]="bidHistory.payment_type"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <ng-container *ngIf="supplier.bid.isPaymentPrepayment()">
            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                Number Of Days Prepaid
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getPrepaymentNumberDaysPrepaidLabel()}}
                <span *ngIf="bidHistory.number_days_prepaid">
                  <jft-bid-history-popover [dataField]="bidHistory.number_days_prepaid"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>

            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                Payment First Delivery Date
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getPrepaymentFirstDeliveryDateLabel()}}
                <span *ngIf="bidHistory.payment_first_delivery_date">
                  <jft-bid-history-popover
                    [dataField]="bidHistory.payment_first_delivery_date"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>

            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                Prepayment Frequency
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getPrepaymentFrequencyLabel()}}
                <span *ngIf="bidHistory.payment_frequency">
                  <jft-bid-history-popover [dataField]="bidHistory.payment_frequency"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>

            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                Prepayment Amount & Currency
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getPrepaymentAmountLabel()}} {{
                supplier.bid.getPaymentCurrencyLabel() }}
                <span *ngIf="bidHistory.currency">
                  <jft-bid-history-popover [dataField]="bidHistory.currency"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>
          </ng-container>

          <ng-container *ngIf="!supplier.bid.isPaymentPrepayment()">
            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                PaymentTerms
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getOpenInvoicePaymentTermsLabel()}}
                <span *ngIf="bidHistory.payment_terms">
                  <jft-bid-history-popover [dataField]="bidHistory.payment_terms"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>

            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                Payment Reference Date
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getOpenInvoiceReferenceDateLabel()}}
                <span *ngIf="bidHistory.payment_reference_date">
                  <jft-bid-history-popover [dataField]="bidHistory.payment_reference_date"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>

            <div class="row border-top min-height">
              <div class="col-12 col-lg-4 p-3">
                Invoice Frequency
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getOpenInvoiceFrequencyLabel(tender)}}
                <span *ngIf="bidHistory.invoice_frequency">
                  <jft-bid-history-popover [dataField]="bidHistory.invoice_frequency"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>

            <div class="row border-top min-height" *ngIf="!tender.company.settings.isHiddenField('bid_invoice_type')">
              <div class="col-12 col-lg-4 p-3">
                Invoice Type
              </div>
              <div class="col-12 col-lg-4 p-3">{{supplier.bid.getOpenInvoiceTypeLabel()}}
                <span *ngIf="bidHistory.invoice_type">
                  <jft-bid-history-popover [dataField]="bidHistory.invoice_type"></jft-bid-history-popover>
                </span>
              </div>
              <div class="col-12 col-lg-4 p-3"></div>
            </div>
          </ng-container>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Payment Currency
            </div>
            <div class="col-12 col-lg-4 p-3">{{ supplier.bid.getPaymentCurrencyLabel() }}
              <span *ngIf="bidHistory.currency">
                <jft-bid-history-popover [dataField]="bidHistory.currency"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Payment Unit
            </div>
            <div class="col-12 col-lg-4 p-3">{{ supplier.bid.getPaymentUnitLabel() }}
              <span *ngIf="bidHistory.unit">
                <jft-bid-history-popover [dataField]="bidHistory.unit"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_method_of_payment')">
            <div class="col-12 col-lg-4 p-3">
              Method Of Payment
            </div>
            <div class="col-12 col-lg-4 p-3">{{ supplier.bid.getPaymentMethodLabel() }}
              <span *ngIf="bidHistory.method_of_payment">
                <jft-bid-history-popover [dataField]="bidHistory.method_of_payment"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_guarantees_deposits_required')">
            <div class="col-12 col-lg-4 p-3">
              Guarantees Deposits Required
            </div>
            <div class="col-12 col-lg-4 p-3">{{ supplier.bid.getPaymentGuaranteesDeposit() }}
              <span *ngIf="bidHistory.guarantees_deposit">
                <jft-bid-history-popover [dataField]="bidHistory.guarantees_deposit"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_bank_guarantee_amount') && supplier.bid.bankGuaranteeAmount">
            <div class="col-12 col-lg-4 p-3">
              Bank Guarantee Amount
            </div>
            <div class="col-12 col-lg-4 p-3">{{ supplier.bid.bankGuaranteeAmount | number:'1.2-2' }}
              <span *ngIf="bidHistory.bank_guarantee_amount">
                <jft-bid-history-popover [dataField]="bidHistory.bank_guarantee_amount"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_bank_guarantee_currency') && supplier.bid.bankGuaranteeCurrency">
            <div class="col-12 col-lg-4 p-3">
              Bank Guarantee Currency
            </div>
            <div class="col-12 col-lg-4 p-3">{{ currencies.getById(supplier.bid.bankGuaranteeCurrency)?.code }}
              <span *ngIf="bidHistory.bank_guarantee_currency">
                <jft-bid-history-popover [dataField]="bidHistory.bank_guarantee_currency"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_transit_time') && supplier.bid.transitTime != null">
            <div class="col-12 col-lg-4 p-3">
              Transit Time (Days)
            </div>
            <div class="col-12 col-lg-4 p-3">{{ supplier.bid.transitTime }}</div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Financial Source
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{supplier.bid.getRateFinancialSourceLabel()}}

              <span *ngIf="bidHistory.financial_source">
                <jft-bid-history-popover [dataField]="bidHistory.financial_source"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>
          <div *ngIf="false" class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Averageing Method
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{supplier.bid.getRateAverageingMethodLabel()}}

              <span *ngIf="bidHistory.averageing_method">
                <jft-bid-history-popover [dataField]="bidHistory.averageing_method"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>
          <div *ngIf="false" class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Averaging Offset
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{supplier.bid.getRateAveragingOffsetLabel()}}
              <span *ngIf="bidHistory.averaging_offset">
                <jft-bid-history-popover [dataField]="bidHistory.averaging_offset"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3"></div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Per Usage Based Mandatory Fees
            </div>
            <div class="col-12 col-lg-4 p-3">
              <div class="float-end">
                <ng-template #popConvD5Title>Supplier's original amount unit/currency</ng-template>
                <ng-template #popConvD5Content>
                  <div *ngFor="let perUsageFee of supplier.bid.perUsageFees">
                    <div *ngIf="supplier.bid.perUsageFees.length && supplier.bid.perUsageFees[0].price">
                      <span>{{ supplier.bid.perUsageFees[0].price.value}}</span>
                      <span *ngIf="supplier.bid.perUsageFees[0].price.currency"> {{
                        supplier.bid.perUsageFees[0].price.currency.code}}</span>
                    </div>
                  </div>
                </ng-template>

              </div>

            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Non-mandatory Fees
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Non-mandatory Fees'"
                [text]="supplier.bid.nonMandatoryFeesText"></jft-read-more-modal>
              <span *ngIf="bidHistory.non_mandatory_fees_text">
                <jft-bid-history-popover [dataField]="bidHistory.non_mandatory_fees_text"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Billing Type
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ supplier.bid.grossNetBilling?.getLabel() }}
              <span *ngIf="bidHistory.billing_type">
                <jft-bid-history-popover [dataField]="bidHistory.billing_type"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div *ngIf="false" class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Intoplane Agent
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ supplier.bid.intoPlaneServiceProvider }}

              <span *ngIf="bidHistory.into_plane_service_provider">
                <jft-bid-history-popover [dataField]="bidHistory.into_plane_service_provider"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.airPortDeliveryMethods.length">
            <div class="col-12 col-lg-4 p-3">
              Delivery to airport
            </div>
            <div class="col-12 col-lg-4 p-3">
              <div *ngFor="let airPortDelivery of supplier.bid.airPortDeliveryMethods">
                {{airPortDelivery.method.name}}
                <span *ngIf="airPortDelivery.percentage"> {{airPortDelivery.percentage}}%</span>
                <span *ngIf="airPortDelivery.isPrimary"> - Primary</span>
              </div>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.airCraftDeliveryMethod.name">
            <div class="col-12 col-lg-4 p-3">
              Delivery to aircraft
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ supplier.bid.airCraftDeliveryMethod.name }}
              <span *ngIf="bidHistory.aircraft_delivery_method">
                <jft-bid-history-popover [dataField]="bidHistory.aircraft_delivery_method"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>


          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_open_fuel_release')">
            <div class="col-12 col-lg-4 p-3">
              Open Fuel Release
            </div>
            <div class="col-12 col-lg-4 p-3">
              {{ supplier.bid.getopenFuelReleaseLabel() }}
              <span *ngIf="bidHistory.open_fuel_release">
                <jft-bid-history-popover [dataField]="bidHistory.open_fuel_release"></jft-bid-history-popover>
              </span>
            </div>
            <div class="col-12 col-lg-4 p-3">

            </div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_pre_flight_notification')">
            <div class="col-12 col-lg-4 p-3">
              Pre-Flight Notification
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Pre-flight notification'"
                [text]="$safeNavigationMigration(supplier.bid.preFlightNotification?.getLabel())"></jft-read-more-modal>
              <span *ngIf="bidHistory.pre_flight_notification">
                <jft-bid-history-popover [dataField]="bidHistory.pre_flight_notification"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_ramp_limitations_notes')">
            <div class="col-12 col-lg-4 p-3">
              Ramp Limitations
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Ramp limitations'"
                [text]="$safeNavigationMigration(supplier.bid.rampLimitations?.getLabel())"></jft-read-more-modal>
              <span *ngIf="bidHistory.ramp_limitations">
                <jft-bid-history-popover [dataField]="bidHistory.ramp_limitations"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Operating Hours
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Operating Hours'"
                [text]="$safeNavigationMigration(supplier.bid.fuelAvailability?.getLabel())"></jft-read-more-modal>
            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Feedback
            </div>
            <div class="col-12 col-lg-8 p-3">
              <span>{{ supplier.bid.feedback }}</span>
            </div>
          </div>

          <!--                    <div class="row border-top min-height">-->
          <!--                        <div class="col-12 col-lg-4 p-3">-->
          <!--                            Weight to Volume Conversion Factor-->
          <!--                        </div>-->
          <!--                        <div class="col-12 col-lg-8 p-3">-->
          <!--                            {{ supplier.bid.supplyCondition.volumeConversion }} USG in 1 MT-->
          <!--                        </div>-->
          <!--                    </div>-->

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Fuel Availability
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.fuelAvailabilityPercentage }}%
              <span *ngIf="bidHistory.fuel_availability_percentage">
                <jft-bid-history-popover
                  [dataField]="bidHistory.fuel_availability_percentage"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height">
            <div class="col-12 col-lg-4 p-3">
              Bid Notes
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Bid Notes'" [text]="supplier.bid.note"></jft-read-more-modal>
              <span *ngIf="bidHistory.note">
                <jft-bid-history-popover [dataField]="bidHistory.note"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <!-- SAF Related Fields -->
          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_saf_mandate') && supplier.bid.safMandate">
            <div class="col-12 col-lg-4 p-3">
              SAF Mandate
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.safMandate === 'Y' ? 'Yes' : 'No' }}
              <span *ngIf="bidHistory.saf_mandate">
                <jft-bid-history-popover [dataField]="bidHistory.saf_mandate"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_saf_mandate_blend') && supplier.bid.safMandateBlend">
            <div class="col-12 col-lg-4 p-3">
              SAF Mandate Blend %
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.safMandateBlend }}%
              <span *ngIf="bidHistory.saf_mandate_blend">
                <jft-bid-history-popover [dataField]="bidHistory.saf_mandate_blend"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_neat_saf_mandated_price') && supplier.bid.neatSaf">
            <div class="col-12 col-lg-4 p-3">
              Neat SAF Price
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ $safeNavigationMigration(supplier.bid.neatSaf.price?.value) | number:'1.2-2' }}
              {{ supplier.bid.neatSaf.price?.currency?.code }} /
              {{ supplier.bid.neatSaf.units?.code }}
              <span *ngIf="bidHistory.neat_saf">
                <jft-bid-history-popover [dataField]="bidHistory.neat_saf"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.neatSafVolume">
            <div class="col-12 col-lg-4 p-3">
              Neat SAF Volume
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.neatSafVolume | number:'1.2-2' }}
              <span *ngIf="bidHistory.neat_saf_volume">
                <jft-bid-history-popover [dataField]="bidHistory.neat_saf_volume"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.safFeeAmount">
            <div class="col-12 col-lg-4 p-3">
              SAF Fee Amount
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.safFeeAmount | number:'1.2-2' }}
              <span *ngIf="supplier.bid.safFeeAmountUnits">
                {{ supplier.bid.safFeeAmountUnits.price?.currency?.code }} /
                {{ supplier.bid.safFeeAmountUnits.units?.code }}
              </span>
              <span *ngIf="bidHistory.saf_fee_amount">
                <jft-bid-history-popover [dataField]="bidHistory.saf_fee_amount"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <!-- Service and Operational Fields -->
          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_iata_service_level') && supplier.bid.iataServiceLevel">
            <div class="col-12 col-lg-4 p-3">
              IATA Service Level
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.iataServiceLevel?.name }}
              <span *ngIf="bidHistory.iata_service_level">
                <jft-bid-history-popover [dataField]="bidHistory.iata_service_level"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.volumeTolerance">
            <div class="col-12 col-lg-4 p-3">
              Volume Tolerance
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.volumeTolerance?.name }}
              <span *ngIf="bidHistory.volume_tolerance">
                <jft-bid-history-popover [dataField]="bidHistory.volume_tolerance"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height"
            *ngIf="!tender.company.settings.isHiddenField('bid_into_plane_service_provider') && supplier.bid.intoPlaneServiceProvider">
            <div class="col-12 col-lg-4 p-3">
              Into Plane Service Provider
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.intoPlaneServiceProvider?.name }}
              <span *ngIf="bidHistory.into_plane_service_provider">
                <jft-bid-history-popover [dataField]="bidHistory.into_plane_service_provider"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.intoPlane">
            <div class="col-12 col-lg-4 p-3">
              Into Plane
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.intoPlane }}
              <span *ngIf="bidHistory.into_plane">
                <jft-bid-history-popover [dataField]="bidHistory.into_plane"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top min-height" *ngIf="supplier.bid.weightToVolume">
            <div class="col-12 col-lg-4 p-3">
              Weight to Volume Conversion
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.weightToVolume | number:'1.2-2' }}
              <span *ngIf="bidHistory.weight_to_volume">
                <jft-bid-history-popover [dataField]="bidHistory.weight_to_volume"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <!-- Unit and Period Fields -->
          <div class="row border-top min-height" *ngIf="supplier.bid.unit">
            <div class="col-12 col-lg-4 p-3">
              Bid Unit
            </div>
            <div class="col-12 col-lg-8 p-3">
              {{ supplier.bid.unit?.code }}
              <span *ngIf="bidHistory.unit">
                <jft-bid-history-popover [dataField]="bidHistory.unit"></jft-bid-history-popover>
              </span>
            </div>
          </div>



          <!-- Supply Conditions -->
          <div class="row border-top min-height" *ngIf="supplier.bid.supplyCondition?.comments">
            <div class="col-12 col-lg-4 p-3">
              Supply Conditions Comments
            </div>
            <div class="col-12 col-lg-8 p-3">
              <jft-read-more-modal [title]="'Supply Conditions Comments'"
                [text]="supplier.bid.supplyCondition.comments"></jft-read-more-modal>
              <span *ngIf="bidHistory.supply_conditions_comments">
                <jft-bid-history-popover [dataField]="bidHistory.supply_conditions_comments"></jft-bid-history-popover>
              </span>
            </div>
          </div>

          <div class="row border-top" *ngIf="supplier.bid.signature">
            <div class="col-12 col-lg-8 p-3">
              <div class="label text-muted">Supplier Signature:</div>
              <div class="preview"><img [src]="supplier.bid.signature | secureImage" /></div>
            </div>
          </div>

        </ng-container>

        <div *ngIf="!supplier.bid" class="row border-top min-height">
          <div class="col-12 col-lg-4 p-3">
            <ng-container *ngIf="awaitingOfferStatuses.includes(supplier.status)">Awaiting offer from {{
              supplier.supplier.name }}</ng-container>
            <ng-container *ngIf="[offerStatuses.DECLINED].includes(supplier.status)">{{ supplier.supplier.name }} will
              not be submitting a bid at this location</ng-container>
          </div>
        </div>

      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="card bg-white mb-6 chat">
        <jft-tender-chat [tender]="tender" [destinationCompany]="supplier.supplier" [contract]="contract">
        </jft-tender-chat>
      </div>

      <div class="card bg-white mb-6">
        <h4 class="card-header bg-white d-flex align-items-center min-height">
          Shared Files <small><jft-count [objects]="getAllDocuments()" [initCount]="0"></jft-count></small>
        </h4>
        <ul class="list-group list-group-flush">
          <li *ngIf="!documents.length && !coverLetter.file && !supplierRequestedDocuments.length"
            class="list-group-item  d-flex align-items-center min-height text-muted">No files to display</li>
          <li class="list-group-item  d-flex align-items-center min-height"
            *ngIf="documents.length || coverLetter.file">
            <div class="text-muted fw-bold">
              Files Uploaded by Airline
            </div>
          </li>
          <document-condensed-list *ngIf="coverLetter && coverLetter.file"
            (documentUpdated)="updateDocumentsEvent($event)" [documents]="[coverLetter.file]" [readonly]="false"
            [tenderId]="tender.id" [class]="'border-bottom'">
          </document-condensed-list>
          <document-condensed-list *ngIf="documents.length" (documentUpdated)="updateDocumentsEvent($event)"
            [documents]="documents" [tenderId]="tender.id" [readonly]="false">
          </document-condensed-list>
          <li class="list-group-item  d-flex align-items-center min-height" *ngIf="supplierRequestedDocuments.length">
            <div class="text-muted fw-bold">
              Files Uploaded by Supplier
            </div>
          </li>
          <document-condensed-list (documentUpdated)="updateDocumentsEvent($event)"
            [documents]="supplierRequestedDocuments" [tenderId]="tender.id" [readonly]="true">
          </document-condensed-list>
          <li class="list-group-item  d-flex align-items-center min-height">
            <label for="add-doc">
              <a class="text-dark pointer"><i class="fas fa-plus me-2" aria-hidden="true"></i>Upload Document</a>
            </label>
            <input id="add-doc" class="d-none" (change)="addDocumentFile($event)" type="file">
          </li>
        </ul>
      </div>

      <div class="card bg-white mb-6 notes">
        <jft-tender-note [tender]="tender" [contract]="contract" [supplierId]="supplier.supplier.id"
          [offer]="supplier"></jft-tender-note>
      </div>
    </div>
  </div>
</div>